var map = {
	"./Linux.svg": 84600,
	"./Windows.svg": 59589,
	"./android.svg": 13427,
	"./chrome.svg": 54600,
	"./default browser.svg": 99269,
	"./default platform.svg": 14470,
	"./explorer.svg": 20999,
	"./ios.svg": 67161,
	"./mac_os.svg": 70912,
	"./microsoft_edge.svg": 97694,
	"./mobile.svg": 50372,
	"./mozilla_firefox.svg": 16552,
	"./safari.svg": 83514,
	"./unknown_os.svg": 95981,
	"./web_default.svg": 77422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96290;